import React, { ComponentProps } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { colors } from 'spw-theme';
import { SPWInput } from './forms';

const useStyles = makeStyles({
  textField: {
    '& .MuiInputBase-input': {
      boxSizing: 'border-box',
      fontSize: '14px',
      height: '40px',
      lineHeight: '20px',
    },
    '& .MuiInputBase-input::placeholder': {
      fontStyle: 'normal',
    },
    '& .MuiInputBase-root': {
      borderRadius: 0,
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.inputBorderColor,
    },
    '& .MuiOutlinedInput-root.Mui-error:not(.Mui-focused) .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.inputBorderColor,
    },
    '& .MuiOutlinedInput-root.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: colors.black,
    },
    '&& .MuiFormLabel-root.Mui-error': {
      color: 'rgba(0, 0, 0, 0.54)',
    },
    '& .MuiFormHelperText-contained': {
      marginLeft: 0,
    },
    '& .MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
});

type Props = ComponentProps<typeof SPWInput>;

const BaseTextField = ({ className, ...props }: Props) => {
  const classes = useStyles();

  return (
    <SPWInput
      {...props}
      inputProps={{ ...props?.inputProps, autoComplete: 'off' }}
      className={`${className} ${classes.textField}`}
    />
  );
};

export default BaseTextField;
